import { defineMessages } from 'react-intl'

const translations = defineMessages({
  headline: {
    defaultMessage: 'My Data Sharing',
    id: 'global.account.link.my_data_sharing'
  },
  text: {
    defaultMessage:
      'You have full control over your data. Manage your approvals and decide what we can and cannot process.',
    id: 'msp.account.my_data_sharing.control_description'
  }
})

export default translations
